"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var swr_hooks_1 = require("@l2p/swr-hooks");
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var ConfirmModal_1 = __importDefault(require("./ConfirmModal"));
var CancelTranaction = function (_a) {
    var id = _a.id, revalidateTransactions = _a.revalidateTransactions;
    var _b = (0, react_1.useState)(false), isOpenConfirm = _b[0], setOpenConfirm = _b[1];
    var _c = (0, swr_hooks_1.useCancelWithdrawal)({
        successAction: function () {
            revalidateTransactions();
            setOpenConfirm(false);
        },
    }), cancelWithdrawal = _c.cancelWithdrawal, isSubmitting = _c.isSubmitting;
    var cancelWithdrawalConfirmation = (0, react_1.useCallback)(function () {
        cancelWithdrawal({ id: id });
    }, [cancelWithdrawal, id]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { 
            // className={`${styles.container} ${isSubmitting ? styles.loading : ''}`}
            className: "".concat(styles_module_scss_1.default.container), onClick: function () {
                setOpenConfirm(true);
            } },
            react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "17", viewBox: "0 0 16 17", fill: "none" },
                react_1.default.createElement("path", { d: "M8 1.5C4.1 1.5 1 4.6 1 8.5C1 12.4 4.1 15.5 8 15.5C11.9 15.5 15 12.4 15 8.5C15 4.6 11.9 1.5 8 1.5ZM8 14.5C4.7 14.5 2 11.8 2 8.5C2 5.2 4.7 2.5 8 2.5C11.3 2.5 14 5.2 14 8.5C14 11.8 11.3 14.5 8 14.5Z" }),
                react_1.default.createElement("path", { d: "M10.7 12L8 9.3L5.3 12L4.5 11.2L7.2 8.5L4.5 5.8L5.3 5L8 7.7L10.7 5L11.5 5.8L8.8 8.5L11.5 11.2L10.7 12Z" }))),
        isOpenConfirm && (react_1.default.createElement(ConfirmModal_1.default, { confirmHandler: cancelWithdrawalConfirmation, closeModalHandler: function () {
                setOpenConfirm(false);
            }, isLoading: isSubmitting }))));
};
exports.default = CancelTranaction;
